import api from './axios';

export const listAjustes = (filtros = {}) => api.get('/ajustes-estoque/', { params: filtros });
export const createAjuste = (data) => api.post('/ajustes-estoque/', data);
